module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av245-b87b34a67c9b6382dc02e5e17003da6f.jpg";